import { c as _c } from "react/compiler-runtime";
import type { BranchPredicateConfig } from '@onefootprint/request-types/dashboard';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import EditableBranchName from '@/components/playbook-builder/components/conditional-node/components/editable-branch-name';
import type { BranchFormData } from '../../../types';
import getSupportedValues from '../../../utils/get-supported-values';
import getUnmatchedValues from '../../../utils/get-unmatched-values';
type DefaultBranchProps = {
  canEdit: boolean;
  predicate: BranchPredicateConfig | null | undefined;
};
const DefaultBranch = t0 => {
  const $ = _c(16);
  const {
    canEdit,
    predicate
  } = t0;
  const {
    t
  } = useTranslation("playbook-builder");
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "cases"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cases = useWatch(t1);
  let t2;
  if ($[2] !== canEdit || $[3] !== cases || $[4] !== predicate || $[5] !== t) {
    const unmatchedValues = getUnmatchedValues(getSupportedValues(predicate), cases.map(_temp));
    let t3;
    if ($[7] !== t) {
      t3 = t(_temp2);
      $[7] = t;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== t3) {
      t4 = <span className="text-tertiary">{t3}:</span>;
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== canEdit) {
      t5 = <EditableBranchName canEdit={canEdit} fieldName="defaultBranch" />;
      $[11] = canEdit;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] !== t4 || $[14] !== t5) {
      t6 = <div className="flex flex-row bg-secondary p-2 items-center gap-3"><div className="text-label-2 text-primary flex items-center gap-2 w-full min-h-[32px] whitespace-nowrap max-md:min-w-0">{t4}{t5}</div></div>;
      $[13] = t4;
      $[14] = t5;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t2 = <div className="bg-primary border border-tertiary rounded flex flex-col w-full overflow-hidden">{t6}{unmatchedValues.length > 0 && <p className="p-3 text-body-2 text-tertiary">{t(_temp3, {
          values: unmatchedValues.join(", ")
        })}</p>}</div>;
    $[2] = canEdit;
    $[3] = cases;
    $[4] = predicate;
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default DefaultBranch;
function _temp(c) {
  return c.condition;
}
function _temp2($) {
  return $.branchNode.defaultBranch;
}
function _temp3($_0) {
  return $_0.branchNode.unmatchedValues;
}